import { RenderController } from './base';
import { ChangeEvent } from 'react';

interface VocabTerm {
  word: string;
  definition: string;
  sentence: string;
  pinyin: string;
  sentencePinyin: string;
}

export default class VocabExportController extends RenderController {
  static targets = ['exportTextarea'];

  exportTextareaTarget: HTMLTextAreaElement;
  vocabTerms: VocabTerm[];

  state = {
    includePinyin: false,
    includeDefinition: false,
    includeSentencePinyin: false,
  };

  connect() {
    this.vocabTerms = JSON.parse(this.data.get('vocabTerms'));
    this.render();
  }

  onChangeControls(evt: ChangeEvent) {
    const newState = {
      includePinyin: false,
      includeDefinition: false,
      includeSentencePinyin: false,
    };
    $(evt.currentTarget).serializeArray().forEach(({ name }) => {
      (newState as any)[name] = true;
    });
    this.setState(newState);
  }

  render() {
    const { includePinyin, includeDefinition, includeSentencePinyin } = this.state;
    const vocabParts = this.vocabTerms.map((term) => {
      const { word, definition, pinyin, sentence, sentencePinyin } = term;
      const termParts = [word];
      if (pinyin && includePinyin) termParts.push(pinyin);
      if (definition && includeDefinition) termParts.push(definition);
      termParts.push(sentence);
      if (sentencePinyin && includeSentencePinyin) termParts.push(sentencePinyin);
      return termParts.join('\n');
    });
    this.exportTextareaTarget.value = vocabParts.join('\n\n');
  }
}
